import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/users/apk/roles/$roleId')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_auth/users/apk/roles/$roleId"!</div>
}
